import React from 'react'
import Header from '../Header/Header'
import TrabajadoresData from '../../Components/Admin/TrabajadoresData/TrabajadoresData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'

export default function Trabajadores() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <TrabajadoresData />
                </div>
            </section>
        </div>
    )
}
